import axios from "axios";

import {
  setLoginMessage,
  setUserId,
  setUserLogInStatus,
  startLoginLoading,
  registerUser,
  setUserEmail,
} from "../../Redux/User/UserActions";

export const clearLoginMessage = () => {
  return (dispatch) => {
    dispatch(setLoginMessage(""));
  };
};
export const setLoginLoading = () => {
  return (dispatch) => {
    dispatch(startLoginLoading());
  };
};
export const setUserLogin = (email, password) => {
  return (dispatch) => {
    axios
      .post("https://decloud-backend.ashusharmaprod.repl.co/login", {
        email: email,
        password: password,
      })
      .then((res) => {
        dispatch(setLoginMessage(res.data.message));
        dispatch(setUserId(res.data.userId));
        dispatch(setUserEmail(res.data.email));
      })
      .then(() => {
        dispatch(setUserLogInStatus(true));
      })
      .catch((err) => {
        console.log(err.response.data.message);
        dispatch(setLoginMessage(err.response.data.message));
      });
  };
};

export const handleLogOut = () => {
  return (dispatch) => {
    dispatch(setUserLogInStatus(false));
  };
};

export const handleRegister = (name, email, phone, password) => {
  return (dispatch) => {
    axios
      .post("https://decloud-backend.ashusharmaprod.repl.co/register", {
        name: name,
        email: email,
        phone: phone,
        password: password,
      })
      .then((res) => {
        dispatch(registerUser(name, email, phone, password));
        dispatch(setLoginMessage(res.data.message));
      })
      .catch((err) => {
        console.log("error inside handleRegister", err);
        dispatch(setLoginMessage(err.response.data.message));
      });
  };
};
